import { render, staticRenderFns } from "./EducationFields.vue?vue&type=template&id=5d8408bb&scoped=true"
import script from "./EducationFields.vue?vue&type=script&lang=js"
export * from "./EducationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8408bb",
  null
  
)

export default component.exports